import React, { useContext, useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PRODUCTS_FAVORITE } from "../querys/index";
import axios from "axios";
import CardProduct from "./cards/CardProduct";
import Loading from "./Loading";
import { AuthUserContext } from "../context/AuthUser";
import { apiBase } from "../services/appenv";

const UrlShare = (props) => {
  const { authUser } = useContext(AuthUserContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sharedList, setSharedList] = useState(null);

  const shareCode = props?.search?.q;

  useEffect(() => {
    const fetchSharedList = async () => {
      if (!shareCode) {
        setError("No share code provided");
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");

        const headers = {};
        if (token) {
          headers["Authorization"] = `Bearer ${token}`;
        }

        const apiUrl = `${apiBase}/api/shared-favorit-lists`;

        const response = await axios.get(apiUrl, {
          headers,
          params: {
            "filters[shareCode][$eq]": shareCode,
            populate: "users_permissions_user",
          },
        });


        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          setSharedList(response.data.data[0]);
        } else {
          throw new Error("Shared list not found");
        }
      } catch (err) {
        if (err.response) {
          setError( "Error loading shared list" );
        } else {
          setError(err.message || "Error loading shared list");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchSharedList();
  }, [shareCode]);



  const productIds = sharedList?.attributes?.productIds || [];

  const { data: dataProducts, loading: productsLoading } = useQuery(
    GET_PRODUCTS_FAVORITE,
    {
      variables: {
        vip: authUser?.typeCustomer === "Admin" ? undefined : "2",
        search: productIds,
      },
      skip: productIds.length === 0,
    }
  );

  const isLoading = loading || productsLoading;

  
  const title = `Favorite #${sharedList?.attributes?.title}`;

  if (error) {
    return (
      <div className="container u-margin-top-3">
        <div className="alert alert-danger">{error}</div>
        {error.includes("Authentication") && (
          <div className="alert alert-info">
            Please log in to view this favorite list.
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {isLoading && <Loading />}
      <div className="container u-margin-top-3">
        {sharedList && <p className="title-of-share-page">{title}</p>}
        <div className="row">
          {dataProducts?.products?.data?.map((item, i) => (
            <div className="col-xl-3 col-lg-4 col-md-4 col-6" key={i}>
              <CardProduct data={item.attributes} like_button={false} />
            </div>
          ))}

          {!isLoading &&
            (!dataProducts?.products?.data ||
              dataProducts.products.data.length === 0) && (
              <div className="col-12 text-center">
                <p>No products found in this favorite list.</p>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default UrlShare;
